import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoxService } from 'src/app/service/box.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Box } from './box';

@Component({
  selector: 'app-box-consulta',
  templateUrl: './box-consulta.component.html',
  styleUrls: ['./box.component.scss', '../../util/conta-financeira/conta-financeira-consulta.scss'],
})
export class BoxConsultaComponent {

  boxs: Box[] = [];
  ordemColunasTabela = ['id', 'name', 'pixBalance', 'caixaBalance', 'cartaoBalance', 'active', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  consultaRealizada = false;
  tipoFiltros = ['ID', 'Nome'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;

  constructor(
    private boxService: BoxService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  consultar(resetPagina = true) {
    if (resetPagina) this.pagina = 0;
    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.boxService.findClientById(idFiltro).subscribe(box => {
        let lista = [box];
        lista = aplicarFiltrosConsulta(lista, this.tipoFiltro, this.parametro, this.situacao, {
          id: b => b.id,
          nome: b => b.name,
          ativo: b => b.active === true || b.active === 'true',
        });
        this.boxs = lista;
        this.totalElementos = lista.length;
        this.consultaRealizada = true;
      }, () => this.snackBar.open('Caixa não encontrado.', 'ERRO', { duration: 2500 }));
      return;
    }
    this.boxService.list(this.pagina, this.tamanho).subscribe(response => {
      const filtrados = aplicarFiltrosConsulta(response.content ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: b => b.id,
        nome: b => b.name,
        ativo: b => b.active === true || b.active === 'true',
      });
      this.boxs = filtrados;
      this.totalElementos = filtrados.length > 0 && (this.parametro || this.situacao !== null)
        ? filtrados.length : response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
    });
  }

  novo() { this.router.navigate(['/box/form']); }
  editar(id: number) { this.router.navigate(['/box/form', id]); }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) return;
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    this.dialog.open(ConfirmaDeleteComponent).afterClosed().subscribe(result => {
      if (result) this.excluir(id);
    });
  }

  private excluir(id: number) {
    this.boxService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Caixa excluido com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }
}
